import React, {useContext} from 'react'
import {makeStyles} from 'external/material'
import {useHistory, useLocation} from 'react-router-dom'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Typography from '@mui/material/Typography'
import useMediaQuery from '@mui/material/useMediaQuery'
import {useTheme} from 'external/material'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import {TeacherContext} from 'teacher/context'
import {isUUID} from 'helpers/utils'

import Content from './content'

const useDialogStyles = makeStyles(dialogStyles)
const useDialogTitleStyles = makeStyles(dialogTitleStyles)
const useDialogContentStyles = makeStyles(dialogContentStyles)

export default function AssessmentStandardsDialog (props) {

  const location = useLocation()
  const history = useHistory()
  const dialogClasses = useDialogStyles()
  const dialogTitleClasses = useDialogTitleStyles()
  const dialogContentClasses = useDialogContentStyles()
  const theme = useTheme()
  const context = useContext(TeacherContext)
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'))

  const {translate, quizDialogs, updateState} = context 

  const open = quizDialogs['search-and-select-question']
  const handleClose = () => {
    updateState({ quizDialogs: {'search-and-select-question': {$set: false}}, searchAndSelectSection: {$set: undefined} })
    if (location.search.length > 0) history.push(location.pathname)
  }

  function handleSelect (question) {
    props.onSelect && props.onSelect(question, context.searchAndSelectSection)
    handleClose()
  }

  return (
    <Dialog
      fullScreen={fullScreen}
      open={open}
      classes={!fullScreen ? dialogClasses : undefined}
      onClose={handleClose}
      aria-labelledby="search-and-select-question-dialog-title"
    >
      <DialogTitle id="search-and-select-question-dialog-title" classes={dialogTitleClasses}>
        <Typography variant="h5" component="div" className="title">{translate('search-and-select-question')}</Typography>
        <IconButton
          aria-label="close"
          className="closeButton"
          onClick={handleClose}
          size="large">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent classes={dialogContentClasses}>
        <Content onSelect={handleSelect} />
      </DialogContent>
    </Dialog>
  );
}

function dialogTitleStyles(theme){
  return {
    root: {
      borderBottom: 'solid 1px #e0e0e0',
      padding: '16px 3px 16px 24px',
      display: 'flex',
      "& .title": {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        color: '#3f5250',
        flexGrow: 1,
      },
    },
  }
}

function dialogContentStyles() {
  return {
    root: {
      display: 'flex',
      justifyContent: 'center',
      padding: 0,
      "& .contentWrapper": {
        display: 'flex',
        flexGrow: 1
      },
    }
  }
}

function dialogStyles(theme) {
  return {
    container: { 
      display: 'flex',
      color: '#626d88',
      width: '100%',
      height: '100%',
      justifyContent: 'center',
    },
    paper: {
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: '#fff',
      border: 'solid 1px #dce1ec',
      height: 'calc(100% - 40px)',
      minWidth: 600,
      maxWidth: 1024,
      borderRadius: 2,
      width: '80%'
    }
  }
}

